module.exports = __webpack_public_path__ + "static/fonts/Fact-ExtraBoldItalic.4b19234.woff2";